export const subscriptionConstants = {
  SUBSCRIPTION_GET_REQUEST: 'SUBSCRIPTION_GET_REQUEST',
  SUBSCRIPTION_GET_SUCCESS: 'SUBSCRIPTION_GET_SUCCESS',
  SUBSCRIPTION_GET_FAILURE: 'SUBSCRIPTION_GET_FAILURE',
};
